module.exports = __webpack_public_path__ + "u.no1.a91d6c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u.no1.jpg
// module id = XtZy
// module chunks = 0